<template>
  <div>
    <edit-menu v-if="!edit" :competition="competition && competition.loaded()" v-on:add="toggleAddCompetition" v-on:create=addNewCompetition v-on:edit=editDetails v-on:delete=confirmDeleteCompetition></edit-menu>

    <b-row v-if="!add">
      <b-col>
        <!-- Competition -->
        <select-competition class="mb-5"
            :competitions=competitions
            :competitionId=id
            :disabled="this.edit !== false"
            v-on:change=setRoute>
        </select-competition>
      </b-col>
    </b-row>

    <div v-if="competition && competition.loaded()" class="mb-5">

        <delete-competition ref="deleteCompetition" :competition="competition" v-on:deleted-competition="$router.replace({name: 'admin.competitions'})"></delete-competition>

        <h5 v-if="!edit">Übersicht</h5>
        <!-- SHOW DETAILS -->
        <show-details v-if="edit !== 'details'" class="mb-5"
          :competition=competition>
        </show-details>

        <!-- EDIT DETAILS -->
        <edit-details v-else
          :competition=competition
          :competitions=competitions
          v-on:cancel="cancel" class="mb-5"></edit-details>

        <h5>Anmeldungen</h5>
        <stats :competition=competition>Stats</stats>

        <h5>Fragenkatalog</h5>
        <router-link :to="{name: 'admin.questions', params: {id: id}}">Hier</router-link>

        <b-row>
          <b-col lg=6 class="d-none d-lg-block d-xl-block">
            <h5>Ergebnisse</h5>
            <prices v-bind:competition="competition"></prices>
          </b-col>

          <b-col cols=12 lg=6 v-if="this.ignoreForInvoicing.indexOf(competition.id) === -1">
            <h5>Rechnungen</h5>
            <b-row>
              <b-col>
                <b-button variant="primary" size="sm" :to="{name: 'admin.competition.invoicing', params: {id: competition.id}}">Ausstehende Rechnungen</b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>


        <!-- Registrations -->
        <h5>Anmeldungen</h5>

        <registrations
            ref="registrations"
            :competition=competition
            class="mt-3">
        </registrations>
    </div>

  </div>
</template>

<script>
import {Competition} from '@/models'
import SelectCompetition from '@/components/competitions/admin/SelectCompetition'
import EditMenu from '@/components/competitions/admin/CompetitionEditMenu'
import DeleteCompetition from '@/components/competitions/admin/DeleteCompetitionModal'
import ShowDetails from '@/components/competitions/admin/ShowDetails'
import EditDetails from '@/components/competitions/admin/EditDetails'
import Stats from '@/components/competitions/admin/Stats'
import Registrations from '@/components/competitions/admin/Registrations'
import Prices from '@/components/competitions/prices/Prices'
import { ignoreForInvoicing } from '@/lib/constants'

export default {
  name: 'Competitions',
  components: {
    selectCompetition: SelectCompetition,
    editMenu: EditMenu,
    deleteCompetition: DeleteCompetition,
    showDetails: ShowDetails,
    editDetails: EditDetails,
    stats: Stats,
    registrations: Registrations,
    prices: Prices
  },

  data: function () {
    return {
      edit: false,
      add: false,
      id: null,
      competition: null,
      competitions: [],
      ignoreForInvoicing
    }
  },

  mounted: function () {
    if (this.$route.params.id) {
      this.id = this.$route.params.id
      this.load()
    }

    this.loadList()
  },

  watch: {
    '$route.params.id': function (id) {
      if (id) {
        this.load(id)
        return
      }

      this.loadList()
      this.$set(this, 'competition', null)
    }
  },

  methods: {
    toggleAddCompetition: function (adding) {
      this.add = adding
    },

    setRoute: function (id) {
      if (id) {
        if (this.$route.params.id !== id) {
          this.$router.replace({name: 'admin.competition', params: {id: id}, query: {deleted: 'false'}})
        }
      } else {
        this.$router.replace({name: 'admin.competitions'})
      }
    },

    setCountry: function (country) {
      if (this.country === country) {
        return
      }

      this.country = country
      this.loadList()
    },

    editDetails: function () {
      this.$eventHub.$emit('alertHide')
      this.edit = this.edit ? false : 'details'
    },

    cancel: function () {
      this.edit = false
    },

    addNewCompetition: function (data) {
      let competition = new Competition(data)
      this.competitions.push({
        value: competition.id,
        text: competition.title()
      })

      this.$set(this, 'competition', competition)
      this.$set(this, 'id', competition.id)
    },

    confirmDeleteCompetition: function () {
      this.$refs.deleteCompetition.show()
    },

    load: function (id = null) {
      if (id) {
        this.id = id
      }

      if (!this.id) {
        return
      }

      let competition = new Competition({id: this.id})
      competition.fetch().then(this.$set(this, 'competition', competition))
    },

    loadList: function () {
      this.axios.get('/competitions')
        .then(rsp => {
          this.competitions = []
          rsp.data.forEach((row) => {
            let competition = new Competition()
            competition.parse(row)

            this.competitions.push({
              value: competition.id,
              text: competition.titleWithCountry()
            })
          })
        })
        .catch(e => { console.log(e) })
    }
  }
}
</script>

<style scoped>
h5 {
  margin-top: 2em;
}
table#registrations ul {
  list-style-type: none;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/competitions/Competitions.vue